import { createContext, useContext } from "react";

export type SafeAreaContextType = {
  topConsumed?: boolean;
  /** Space occupied by fixed app notices above full-screen overlays. */
  overlayTopInset?: number;
  bottomConsumed?: boolean;
};

const SafeAreaContext = createContext<SafeAreaContextType>({
  bottomConsumed: false,
  topConsumed: false,
});

export const SafeAreaProvider = SafeAreaContext.Provider;
export const useSafeAreaContext = () => useContext(SafeAreaContext);
